import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Unfavorite = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M14 2L2 14" stroke="#6D778B" strokeLinecap="round" strokeLinejoin="round" />
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.89673 2.02054C8.52991 1.2773 7.47007 1.2773 7.10326 2.02054L5.70867 4.84627L2.5903 5.2994C1.77008 5.41858 1.44257 6.42656 2.03608 7.00509L4.29256 9.20462L4.27526 9.3055L5.04023 8.54053C5.02437 8.52269 5.00782 8.50534 4.99057 8.48853L2.73409 6.28901L5.85247 5.83588C6.17818 5.78855 6.45975 5.58398 6.60541 5.28884L7.99999 2.46311L9.03021 4.55055L9.77687 3.8039L8.89673 2.02054ZM10.5372 4.88201L9.7392 5.68004C9.86042 5.76032 9.9994 5.81436 10.1475 5.83588L13.2659 6.28901L11.0094 8.48853C10.7737 8.71827 10.6662 9.04927 10.7218 9.37366L11.2545 12.4794L8.46533 11.0131C8.17401 10.8599 7.82597 10.8599 7.53465 11.0131L4.74549 12.4794L5.1193 10.2999L3.89466 11.5246L3.75988 12.3104C3.61977 13.1273 4.4772 13.7503 5.21083 13.3646L7.99999 11.8982L10.7892 13.3646C11.5228 13.7503 12.3802 13.1273 12.2401 12.3104L11.7074 9.20462L13.9639 7.00509C14.5574 6.42656 14.2299 5.41858 13.4097 5.2994L10.5372 4.88201Z"
        />
      </svg>
    )
  },
)

export default Unfavorite
